/**
 * Authentication utility functions for Thaklis
 */

// Get the authentication token from local storage
export const getAuthToken = () => {
  // Prefer 'jwt_token', fallback to 'token', then legacy 'authToken'
  return (
    localStorage.getItem('jwt_token') ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken')
  );
};

// Set the authentication token in local storage
export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

// Remove the authentication token from local storage
export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

// Check if the user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};

// Get the current user from local storage
export const getCurrentUser = () => {
  const userString = localStorage.getItem('currentUser');
  return userString ? JSON.parse(userString) : null;
};

// Set the current user in local storage
export const setCurrentUser = (user) => {
  localStorage.setItem('currentUser', JSON.stringify(user));
};

// Remove the current user from local storage
export const removeCurrentUser = () => {
  localStorage.removeItem('currentUser');
};

// Add auth header to request config
export const addAuthHeader = (config = {}) => {
  const token = getAuthToken();
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Logout function
export const logout = () => {
  removeAuthToken();
  removeCurrentUser();
  // Redirect to login page or perform other logout actions
  window.location.href = '/login';
};
